module.exports = __webpack_public_path__ + "img/fig30.455cdc16.jpg";